'use client';

import CustomLink from 'components/shared/CustomLink';
import { CustomImage } from '..';
import { analytics } from 'lib/analytics/analytics';
import styles from './Ogdb.module.css';

export const Ogdb = ({ className }: { className?: string }) => {
  return (
    <div className={`${styles.root}${className ? ` ${className}` : ''}`}>
      <div className={styles.section}>
        {/* both crops render; CSS shows one per viewport (useWindowSize is 0 on SSR) */}
        <CustomImage
          src="web_v2/m1/ogdb/bg-desktop.png"
          fill
          alt=""
          objectFit="contain"
          className="img-desktop"
        />
        <CustomImage
          src="web_v2/m1/ogdb/bg-mobile.png"
          fill
          alt=""
          objectFit="contain"
          className="img-mobile"
        />
        <CustomImage
          src="web_v2/m1/ogdb/bg-desktop.png"
          fill
          alt=""
          objectFit="contain"
          className="bg-blur img-desktop"
        />
        <CustomImage
          src="web_v2/m1/ogdb/bg-mobile.png"
          fill
          alt=""
          objectFit="contain"
          className="img-mobile"
        />
        <div className={styles.content}>
          <h3>Find the Glucose response for your favourite foods </h3>
          <CustomLink
            onClick={() =>
              analytics.track('link Ogdb clicked', { location: '/pricing' })
            }
            data-link="ogdb"
            href="/ogdb"
          >
            Explore OGDb
          </CustomLink>
        </div>
      </div>
    </div>
  );
};
